import { wordPressRequest } from "./wordpress/ajax";

console.log("hello");
// Categories Filter

document.getElementById("resourceFilterCategories").addEventListener("change", (event) => {
	const url = phpVals.adminAjax;

	console.log("hello");

	// Get Filter Categories & Tags

	var filterOptions = [];
	var checkboxes = document.getElementById("resourceFilterCategories").querySelectorAll("input[type=checkbox]:checked");

	for (var i = 0; i < checkboxes.length; i++) {
		filterOptions.push(checkboxes[i].value);
	}

	var filterTagOptions = [];
	var tagCheckboxes = document.getElementById("resourceFilterTags").querySelectorAll("input[type=checkbox]:checked");

	for (var i = 0; i < tagCheckboxes.length; i++) {
		filterTagOptions.push(tagCheckboxes[i].value);
	}

	console.log(filterOptions);

	// Setup formdata
	let data = new FormData();
	data.append("action", "bt_resource_filter");
	data.append("nonce", phpVals.btNonce);
	data.append("terms", filterOptions);
	data.append("tags", filterTagOptions);

	const params = new URLSearchParams(data);

	wordPressRequest("POST", url, params)
		.then((data) => {
			document.getElementById("activeResourcesList").innerHTML = "";
			document.getElementById("activeResourcesList").insertAdjacentHTML("beforeend", data.content);
		})
		.catch((error) => {
			console.error(error);
		});
});

// Tags Filter

document.getElementById("resourceFilterTags").addEventListener("change", (event) => {
	const url = phpVals.adminAjax;

	console.log("hello");

	// Get Filter Categories & Tags

	var filterOptions = [];
	var checkboxes = document.getElementById("resourceFilterCategories").querySelectorAll("input[type=checkbox]:checked");

	for (var i = 0; i < checkboxes.length; i++) {
		filterOptions.push(checkboxes[i].value);
	}

	var filterTagOptions = [];
	var tagCheckboxes = document.getElementById("resourceFilterTags").querySelectorAll("input[type=checkbox]:checked");

	for (var i = 0; i < tagCheckboxes.length; i++) {
		filterTagOptions.push(tagCheckboxes[i].value);
	}

	// Setup formdata
	let data = new FormData();
	data.append("action", "bt_resource_filter");
	data.append("nonce", phpVals.btNonce);
	data.append("terms", filterOptions);
	data.append("tags", filterTagOptions);

	const params = new URLSearchParams(data);

	wordPressRequest("POST", url, params)
		.then((data) => {
			document.getElementById("activeResourcesList").innerHTML = "";
			document.getElementById("activeResourcesList").insertAdjacentHTML("beforeend", data.content);
		})
		.catch((error) => {
			console.error(error);
		});
});
